import { ReactNode, useMemo } from 'react';

import BufferTimes from '@/features/Settings/components/pages/BufferTimes';
import ClientMappings from '@/features/Settings/components/pages/ClientMappings';
import CombineRules from '@/features/Settings/components/pages/CombineRules';
import Training from '@/features/Settings/components/Training';
import VariableTimes from '@/features/Settings/components/pages/VariableTimes';
import { useParams } from 'react-router-dom';

export type SettingsRouteProps = {
  route: string;
};
export type SettingsRoute = (props: SettingsRouteProps) => ReactNode;

const Settings = (): ReactNode => {
  const { ['sub-route']: subRoute } = useParams<Record<string, string>>();

  const Content = useMemo((): SettingsRoute => {
    switch (subRoute) {
      case 'variable-times':
        return VariableTimes;
      case 'combine-rules':
        return CombineRules;
      case 'client-mappings':
        return ClientMappings;
      case 'training':
        return Training;
      case 'buffer-times':
      default:
        return BufferTimes;
    }
  }, [subRoute]);

  return <Content route={subRoute} />;
};

export default Settings;
